import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TcNav from "./TcNav";
import "../../styles/tcDash.css";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
export default function UpdateCase() {
  const navigate = useNavigate();
  const [laws, setLaws] = useState([]);

  const getLaws = async () => {
    try {
      const response = await fetch("http://localhost:8000/laws");
      const data = await response.json();
      setLaws(data);
    } catch (error) {
      console.error("Error fetching violations data:", error);
    }
  };

  useEffect(() => {
    getLaws();
    getCase();
  }, []);

  const [formData, setFormData] = useState({
    caseID: "",
    licenseNo: "",
    date: "",
    violated: "",
    fines: "",
    location: "",
    status: "",
    request: "",
  });

  const params = useParams();

  const getCase = async () => {
    try {
      let response = await fetch(`http://localhost:8000/case/${params.key}`);
      response = await response.json();
      // Check if the response is an array
      const caseData = Array.isArray(response) ? response[0] : response;

      setFormData(caseData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.warn(typeof formData);

    let result = await fetch(`http://localhost:8000/case/${params.key}`, {
      method: "Put",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "Application/json",
      },
    });
    result = await result.json();

    if (result) {
      toast.success("Case Updated", {
        position: "top-left",
        autoClose: 2000,
        theme: "dark",
      });
    }
  };

  return (
    <div>
      <header>
        <TcNav />
      </header>
      <main>
        {/* Cases */}
        <section className="searches">
          <div className="container mt-5 pt-1">
            <div className="row">
              <div className="col-12 col-sm-7 col-md-6 m-auto">
                <div className="card border-0 shadow custom-card">
                  <div className="card-body p-4  text-light">
                    {/* User Icon */}
                    <div className="d-flex justify-content-center mt-4 mb-4">
                      <i className="fa-solid fa-user"></i>
                    </div>

                    {/* Input fields for user information */}

                    <form onSubmit={handleSubmit}>
                      <input
                        type="text"
                        className="form-control mt-2"
                        placeholder="Case No"
                        name="caseID"
                        value={formData.caseID}
                        onChange={handleChange}
                      />

                      <input
                        type="text"
                        name="licenseNo"
                        className="form-control col mt-2"
                        placeholder="License No"
                        value={formData.licenseNo}
                        onChange={handleChange}
                      />

                      {/* laws */}
                      <select
                        className="form-select mt-2"
                        aria-label="Default select example"
                        name="violated"
                        value={formData.violated}
                        onChange={handleChange}
                      >
                        <option selected>Select Violation Type</option>
                        {laws.map((law) => (
                          <option key={law.id} value={law.violations}>
                            {law.violations}
                          </option>
                        ))}
                      </select>

                      {/* status */}
                      <select
                        className="form-select mt-2"
                        aria-label="Default select example"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                      >
                        <option selected>Select Status</option>
                        <option value="unresolved">Unresolved</option>
                        <option value="resolved">Resolved</option>
                        <option value="payment-pending">Pending Payment</option>
                        <option value="wrong-violation-fixed">
                          Wrong Violation Resolved
                        </option>
                      </select>

                      <div className="text-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-outline-light w-100"
                        >
                          Update
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <ToastContainer />
    </div>
  );
}
